import { BCAHeaderWithAPI, BCAFooter, Box } from "@bca/ui-library";

const isProd = process.env.ENVIRONMENT === "production";
const isUat = process.env.ENVIRONMENT === "preview";

const magnoliaRootUrl = isProd
  ? "https://www.bca.co.uk/"
  : isUat
    ? "https://cms.uat.britishcarauctions.net/"
    : "https://cmsmain-dev.bca.co.uk/";

interface LayoutProps {
  idToken: string;
  children: any;
  isToUseAuthZero: boolean;
  isAuthenticated: boolean;
  logoutUrl?: string;
  user?: { firstName: string; lastName: string };
}

const Layout: React.FunctionComponent<LayoutProps> = ({
  user,
  idToken,
  children,
  isToUseAuthZero,
  isAuthenticated,
  logoutUrl,
}: any) => {
  const onHandleLogout = () => {
    if (isToUseAuthZero && isAuthenticated && logoutUrl) {
      window.location.href = logoutUrl;
    }
  };

  const shouldShowHeader = () => {
    if (!isToUseAuthZero) {
      return true;
    }

    if (isToUseAuthZero && isAuthenticated && user) {
      return true;
    }

    return false;
  };

  return (
    <>
      {shouldShowHeader() && (
        <BCAHeaderWithAPI
          urls={{
            myBCAInfo: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/MyBCA-Menu`,
            navLinks: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Main-Menu`,
            // this is a required prop that is no longer needed/used
            login: "",
            logout: isToUseAuthZero
              ? null
              : isProd
                ? `https://login.bca.co.uk/connect/endsession?id_token_hint=${idToken}&post_logout_redirect_uri=https://www.bca.co.uk`
                : `https://login.uat.britishcarauctions.net/connect/endsession?id_token_hint=${idToken}&post_logout_redirect_uri=https://cms.uat.britishcarauctions.net`,
            myBCALink: isProd
              ? "https://www.bca.co.uk/mybca/dashboard/"
              : "https://cms.uat.britishcarauctions.net/mybca/dashboard/",
            vehicleOptions: isProd
              ? "https://auctionview.bca.co.uk/buyer/api/v1_0/FacetedSearchApi/VehicleTypes?cultureCode=en"
              : "https://auctionview.uat.britishcarauctions.net/buyer/api/v1_0/FacetedSearchApi/VehicleTypes?cultureCode=en",
            auctionViewRoot: isProd
              ? "https://auctionview.bca.co.uk/"
              : "https://auctionview.uat.britishcarauctions.net/",
            searchRootURL: isProd
              ? "https://www.bca.co.uk/"
              : "https://cms.uat.britishcarauctions.net/",
            trackedLink: isProd
              ? "https://www.bca.co.uk/search?requestOrigin=Tracked"
              : "https://cms.uat.britishcarauctions.net/search?requestOrigin=Tracked",

          }}
          user={user}
          onSignOutClick={onHandleLogout}
        />
      )}
      <Box css="z-index: 0; position: relative;">{children}</Box>
      <BCAFooter
        urls={{
          navigationLinks: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Footer`,
          legalInfo: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Footer-Legal`,
          socialMedia: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Social-Links`,
        }}
      ></BCAFooter>
    </>
  );
};

export default Layout;
